import { render, staticRenderFns } from "./TfacInfoForm.vue?vue&type=template&id=49f44c36"
import script from "./TfacInfoForm.vue?vue&type=script&lang=js"
export * from "./TfacInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports